<clinic-layout [title]="'Consultation #' + orderId" [reviewPage]="true">
    <patient-details *ngIf="!!patient" [patient]="patient"></patient-details>
    <app-questionnaire-brief *ngIf="!!gpNote" [orderId]="orderId" [notes]="gpNote"
        [viewOnly]="true" [orderItem]="orderItem"></app-questionnaire-brief>
</clinic-layout>